module.exports = __webpack_public_path__ + "img/ferramentas.6a9f8969.svg";